import React from 'react'
import ClientesLatitudSur from '../../img/ClientesLatitudSur.png';

const Clientes = () => {
   return (
      <div className="animated fadeIn" id="clientes">
         <div className="container section">
            <div className="row">
               <div className="col s12 m12 l12 x12 center">
                  <h4 className="black-text text-darken-4"><strong>Nuestros Principales Clientes</strong></h4>
                  <img src={ClientesLatitudSur} alt="" className="responsive-img"/>
               </div>
            </div>      
         </div>
      </div>
   )
}

export default Clientes